import {
    TRYING_GOALS_ACTION,
    TRYING_GOALS_ACTION_SUCCESS,
    TRYING_GOALS_ACTION_ERROR
} from '../Types';

const INITIAL_STATE = {
    TryingGoalsAction: false,
    TryingGoalsActionError: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TRYING_GOALS_ACTION:
            return { ...state, TryingGoalsAction: true, TryingGoalsActionError: null };
        case TRYING_GOALS_ACTION_ERROR:
            return { ...state, TryingGoalsAction: false, TryingGoalsActionError: action.payload };
        case TRYING_GOALS_ACTION_SUCCESS:
            return { ...state, TryingGoalsAction: false, TryingGoalsActionError: null };
        default:
            return state;
    }
};
